import { useContext } from 'react';
import './style.scss';
import StudyStep from '../StudyStep';
import MemberFeeStep from '../MemberFeeStep';
import WorkStep from '../WorkStep';
import MeritsStep from '../MeritsStep';
import { FormDataContext } from '../FormDataProvider';

function MembershipStep() {

    const { handleStepChoise, handleSingleFormDataChange } = useContext(FormDataContext);

    const handleStudyStep = (e, hasExam) => {
        handleStepChoise(e, StudyStep, { has_exam: hasExam});
    }

  return (
    <div className="membership-step">
      <h2>Medlemskap</h2>
      <p className="desc">Välj vilken typ av medlemskap du ansöker om</p>
        <form>
            <div className="step-bubble" name="reentry[]" value="Ja" onClick={(e) => handleStepChoise(e, MemberFeeStep)}>
                <h3>Återinträde</h3>
                <p>Jag har varit medlem i Svenska Tecknare under de senaste tre åren och önskar återinträde. Har det gått mer än tre år sedan återinträde krävs en ny ansökan.</p>
            </div>
            <div className="step-bubble" name="studies[]" value="Ja" onClick={(e) => handleStudyStep(e, false)}>
                <h3>Studerande</h3>
                <p>Jag ansöker om medlemskap som studerande vid någon av Svenska Tecknares godkända utbildningar för medlemskap. Gäller även dig som ansöker om medlemskap i anslutning till en föreläsning av Svenska Tecknare på din utbildning.</p>
            </div>
            <div className="step-bubble" name="studies[]" value="Ja" onClick={(e) => handleStudyStep(e, true)}>
                <h3>Jag har en examen från en godkänd utbildning</h3>
                <p>Jag ansöker om medlemskap på studiemeriter/har en examen från en godkänd utbildning.</p>
            </div>
            <div className="step-bubble" name="employed[]" value="Ja" onClick={(e) => handleStepChoise(e, WorkStep)}>
                <h3>Anställd</h3>
                <p>Jag är anställd.</p>
            </div>
            <div className="step-bubble" name="business_type_custom[]" value="Ja" onClick={(e) => handleStepChoise(e, MeritsStep)}>
                <h3>Annat/Annan verksamhet</h3>
                <p>Det här valet gäller dig som är egenanställd med enskild firma, driver aktiebolag eller liknande. Eller för dig som inte passar in på något av ovanstående val.</p>
            </div>
        </form>
        <p>En lista över godkända utbildningar hittar du <a target="_blank" href="/studentmedlemskap/">här</a>.<br /><br /> 
        Observera att utländska utbildningar inte finns i listan men kan komma att godkännas för medlemskap. Invalsnämnden gör alltid en helhetsbedömning av din ansökan. Vid frågor, kontakta <a href="mailto:info@svenskatecknare.se">info@svenskatecknare.se</a>.</p>
    </div>
  );
}

export default MembershipStep;
